import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { ERROR, START } from 'shared/data/quoteSteps';
import { selectFabricationDataForActions } from 'us_quickturn_prototype_pcb/pcb_fabrication/slice/selectors';
import { doEmailQuote } from 'us_quickturn_prototype_pcb/pcb_fabrication/slice/thunks';

import { alert } from 'shared/product_tabs/alert/alertSlice';
import QuoteAction from 'shared/components/QuoteAction';
import EmailQuoteModal from 'shared/components/EmailQuoteModal';

const QuoteActionBar = () => {
  const dispatch = useDispatch();
  const [showEmailQuoteModal, setShowEmailQuoteModal] = useState(false);
  const {
    quote,
    quoteStep,
    parametersChanged,
    productToCompare,
  } = useSelector(selectFabricationDataForActions);

  const onEmailQuote = () => {
    if (parametersChanged) {
      dispatch(alert({
        variant: 'danger',
        title: Spree.translations.parameters_have_changed_title,
        message: Spree.translations.parameters_have_changed,
      }));
    } else {
      setShowEmailQuoteModal(true);
    }
  };

  const dismissEmailQuoteModal = () => {
    setShowEmailQuoteModal(false);
  };

  const onSendEmailQuote = async (data) => {
    try {
      await dispatch(doEmailQuote({ data })).unwrap();
      toast(Spree.translations.email_quote_success, { type: 'success' });
    } catch (error) {
      toast(Spree.translations.email_quote_error, { type: 'error' });
    } finally {
      dismissEmailQuoteModal();
    }
  };

  const onCompareProducts = () => {
    if (parametersChanged) {
      dispatch(alert({
        variant: 'danger',
        title: Spree.translations.parameters_have_changed_title,
        message: Spree.translations.parameters_have_changed,
      }));
    } else {
      // eslint-disable-next-line no-undef
      window.open(`/products/${productToCompare.slug}/compare/${quote.id}`);
    }
  };

  const onCustomQuote = () => {
    // eslint-disable-next-line no-undef
    window.open(Spree.routes.new_custom_quote_request_url);
  };

  const disabled = quoteStep === START || quoteStep === ERROR;

  return (
    <div className="quote-action-bar">
      <QuoteAction
        disabled={disabled}
        label="Email quote"
        onClick={onEmailQuote}
        icon={Spree.image_assets.email_icon} />
      <QuoteAction
        disabled={disabled}
        label={`Compare with ${productToCompare.name}`}
        onClick={onCompareProducts}
        icon={Spree.image_assets.compare_icon} />
      <QuoteAction
        href={Spree.routes.new_custom_quote_request_url}
        label="Custom Quote"
        onClick={onCustomQuote}
        icon={Spree.image_assets.custom_quote_icon} />

      <EmailQuoteModal
        show={showEmailQuoteModal}
        quote={quote}
        onHide={dismissEmailQuoteModal}
        onSend={onSendEmailQuote} />
    </div>
  );
};

export default QuoteActionBar;
